import { useRef } from "react";
import * as bootstrap from 'bootstrap';
export const SingleInputModal = ({ requestpayload, setRequestPayload, handleSubmit, handleClose, popupType }) => {

    const modalRef = useRef(null);
    let bootstrapModal = null;


    const openModal = () => {
        if (bootstrapModal) {
            bootstrapModal.show();
            //setShow(true);
        }
    }


    return (
        <div className="modal fade" ref={modalRef} id="createCollectionModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="createCollectionModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header border-0">
                        <h1 className="modal-title fs-5" id="createCollectionModalLabel">Create {popupType}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="mb-3">
                                <label htmlFor="collectionName" className="form-label">{popupType} name/label</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="collectionName"
                                    placeholder={`Enter ${popupType} name`}
                                    value={requestpayload?.label}
                                    required
                                    autoComplete="c-name"
                                    onChange={(e) => setRequestPayload({ ...requestpayload, label: e.target.value })}
                                />
                            </div>

                            <div className="d-flex justify-content-end">
                                <button className="btn btn-sm btn-outline-secondary me-2" type="reset">Clear</button>
                                <button className="btn btn-sm btn-primary" type="submit">Create {popupType}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}